/**
 * Shared React contexts for the form system.
 *
 * These must be created once and shared — `createFormHook` (index.ts) wires
 * them into the form, and field/form-level components read from them. A
 * separate file avoids circular imports between index.ts and its consumers.
 */

import { createFormHookContexts } from '@tanstack/react-form'

export const { fieldContext, useFieldContext, formContext, useFormContext } =
  createFormHookContexts()
